import axios from "axios";
import { aspNetUrl } from "../../axiosInstance";

export const getStationDeliveryHours = (stationId) => {
  return axios.get(`${aspNetUrl}StationDeliveryHours?StationId=${stationId}`, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const StationDeliveryHoursPost = (data) => {
  return axios.post(`${aspNetUrl}StationDeliveryHours`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const getDateType = () => {
  return axios.get(`${aspNetUrl}date_type`, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const dateTypePost = (data) => {
  return axios.post(`${aspNetUrl}date_type`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const getDateDayOfWeek = () => {
  return axios.get(`${aspNetUrl}date_day_of_week`, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const dateDayOfWeekPost = (data) => {
  return axios.post(`${aspNetUrl}date_day_of_week`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};
export const getSpecialDays = () => {
  return axios.get(`${aspNetUrl}date_sepcial`, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const specialDaysPost = (data) => {
  return axios.post(`${aspNetUrl}date_sepcial`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};
